import { Box, Typography, Card, Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, Badge, Stack, Dialog, DialogTitle, DialogContent } from "@mui/material"
import "./admindashboard.css"
import CustomCard from '../../Components/AdminDashboard/CustomCard.js'
import cardData from "../../../src/pages/AdminDashboard/cardData.js"
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import moment from "moment";
import { Divider, Tag, Typography as typography_antd } from "antd";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FreeBreakfastOutlinedIcon from '@mui/icons-material/FreeBreakfastOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import env from "../../config/env.js";
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";

function AdminDashboardUI({ data, loading, attendance }) {

  const [openDialog, setopenDialog] = useState(false);
  const [selectedAttendanceList, setSelectedAttendanceList] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState("");

  console.log(data, 'data')
  const formattedDate = moment().format("dddd, DD MMMM YYYY");

  const updatedCardData = cardData.map((item) => ({
    ...item,
    count: data?.[item.Key] || 0
  }));

  // console.log(attendance.users.data,"jgghuh")

  // Format a timestamp like "2024-03-04T10:08:28" to "hh:mm AM/PM"
  const formatTime = (value) => {
    if (!value) return "-";
    return moment(value).format("hh:mm A");
  };

  //  Format a duration in seconds to "xh ym" (e.g. 3h 45m)
  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0h 0m";
    const duration = moment.duration(Number(seconds), 'seconds');
    return `${Math.floor(duration.asHours())}h ${duration.minutes()}m`;
  };

  // const updatedCardData = useMemo(() => {
  //   return cardData.map((item) => ({
  //     ...item,
  //     count: data?.[item.Key] || 0
  //   }))
  // }, [data]);

  const leave_type = {
    1: "Full Day",
    2: "First Half",
    3: "Second Half",
  };

  const getPunchStatus = (row) => {

    // No punch in/out at all
    if (!row.attendanceList || row.attendanceList.length === 0) {
      return {
        label: "Not Started",
        bg: "#ffd6d6",
        color: "maroon",
        border: "1px solid #f27e7eff",
      };
    }

    const latestRecord = row.attendanceList?.[row.attendanceList.length - 1];

    // Check if any break is ongoing
    // const isInBreak = row.break.some(
    //   (b) => b.break_in && (!b.break_out || b.break_out === "")
    // );

    // If punch in exists and punch out is missing
    if (latestRecord?.punch_in && !latestRecord?.punch_out) {

      if (latestRecord?.break === 1) {
        return {
          label: "In Break",
          bg: "#fff3cd",
          color: "#856404",
          border: "1px solid #f2cb4aff"
        }; // yellow
      }

      return {
        label: "Running",
        bg: "#c8fcdb",
        color: "green",
        border: "1px solid #37d571ff"
      }; // green
    }

    // if (latestRecord?.punchIn && latestRecord?.punchOut) {
    //   return { 
    //     label: "Stopped", bg: "#ffd6d6", color: "maroon", border: "1px solid #f27e7eff" }; // red
    // }

    return {
      label: "Stopped",
      bg: "#ffd6d6",
      color: "maroon",
      border: "1px solid #f27e7eff"
    }; // red
  };

  return (
    <Box>
      <Box className='dashboard-container'>
        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className='dashboard-title'>Admin Dashboard</Typography>
          <Box className="display_flex align_item_center">
            <CalendarMonthIcon
              className="text"
              sx={{
                fontSize: "19px !important",
                marginRight: "5px",
                marginTop: "2px",
              }}
            />
            <Typography variant="h6" className="font_bold" sx={{ fontSize: '20px !important' }}>{formattedDate}</Typography>
          </Box>
        </Box>
        <Box className='card-grid'>
          <Grid container spacing={2}>
            {updatedCardData?.map((item, index) => {
              return (<Grid item xs={12} sm={6} md={6} lg={3} xl={3} key={index}>
                <CustomCard className="custom-card"
                  title={item.title}
                  count={item?.count}
                  icon={item.icon}
                />
              </Grid>)
            })}
          </Grid>
        </Box>
      </Box>

      <Box padding={1} >
        <Card sx={{ padding: 2, borderTopLeftRadius: 15, borderTopRightRadius: 15, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
          <Typography
            sx={{
              color: "#244DA0",
              fontFamily: "ImportedMilliardSemibold !important"
            }}
          >
            Employee Status
          </Typography>
        </Card>
        <TableContainer
          component={Paper}
          className="table-container"
          style={{
            maxHeight: 'calc(100vh - 320px)',
            overflowY: 'auto',
            width: '100%',
            borderRadius: 0
          }}
        >
          <Table sx={{
            minWidth: 650,
            '& th, & td': {
              border: '1px solid #f0f0f0',
            },
          }} >
            <TableHead className="table_Header_color" sx={{ height: "50px" }}>
              <TableRow
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#244DA0",
                }}
              >

                <TableCell style={{ color: "white", }}>
                  Employee
                </TableCell>

                <TableCell style={{ color: "white" }}>
                  Status
                </TableCell>

                <TableCell style={{ color: "white" }}>
                  Punch In/Out
                </TableCell>

                <TableCell style={{ color: "white" }}>
                  Break Time
                </TableCell>

                <TableCell style={{ color: "white" }}>
                  Working Hours
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <span class="loader" />
                  </TableCell>
                </TableRow>
              ) : attendance?.user?.length > 0 ? (
                attendance.user.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Box display="flex" alignItems="center" >
                        {row?.profilePic ? (
                          <img
                            style={{
                              height: "40px",
                              width: "40px",
                              borderRadius: "50%",
                              objectFit: "fill",
                            }}
                            src={`${env.backend_api_endpoint}/files/${row?.profilePic}`}
                            alt={`${row?.profilePic}`}
                          />
                        ) : (
                          // <AccountCircleIcon
                          //   style={{
                          //     height: 45,
                          //     width: 45,
                          //     borderRadius: "50%"
                          //   }}
                          // />
                          <Tag
                            style={{
                              borderRadius: "60px",
                              fontWeight: "bold",
                              border: 0,
                              height: "40px",
                              width: "40px",
                              fontSize: "15px",
                              backgroundColor: "#c8e4fc",
                              color: "navy",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {row?.userName?.split(" ").map((word) => word.charAt(0).toUpperCase()).join("")}
                          </Tag>
                        )}
                        <Typography
                          sx={{
                            '&.MuiTypography-root': {
                              fontSize: "14px !important"
                            },
                            marginLeft: 1
                          }}
                        >
                          {row.userName}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Stack direction="column" gap={1}>
                        {(() => {
                          const { label, bg, color, border } = getPunchStatus(row);

                          return (
                            <Tag
                              style={{
                                borderRadius: "20px",
                                fontWeight: "bold",
                                border: border,
                                backgroundColor: bg,
                                // row.punchIn?.length > 0 ? "#c8fcdb" : "#ffd6d6",
                                color: color,
                                // row.punchIn?.length > 0 ? "green" : "maroon",
                              }}
                            >
                              {label}
                            </Tag>
                          )
                        })()}
                        <Tag
                          style={{
                            borderRadius: "20px",
                            fontWeight: "bold",
                            border:
                              row.leaveData?.length > 0 ? "1px solid #f27e7eff" : "1px solid #5cacf3ff",
                            backgroundColor:
                              row.leaveData?.length > 0 ? "#ffd6d6" : "#c8e4fc",
                            color:
                              row.leaveData?.length > 0 ? "maroon" : "navy",
                          }}
                        >
                          {row.leaveData?.length > 0 ? leave_type[row.leaveData[0]?.leave_duration] || "Leave" : "Available"}
                        </Tag>

                        {/* <Badge
                          badgeContent={
                            <Typography >
                              {row.leaveData?.length > 0 ? "On Leave" : (row.punchIn ? "Present" : "Absent")}
                            </Typography>
                          }
                          sx={{
                            '& .MuiBadge-badge': {
                              backgroundColor: row.leaveData?.length > 0
                                ? '#c8e4fc'
                                : row.punchIn ? '#c8fcdb' : '#ffd6d6',
                              color: row.leaveData?.length > 0
                                ? 'blue'
                                : row.punchIn ? 'green' : 'red',
                              borderRadius: '8px',
                              height: '20px',
                            },
                          }}
                        /> */}
                      </Stack>
                    </TableCell>

                    <TableCell sx={{ width: "20%" }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">

                        <Box display="flex" flexDirection="column">
                          <Box display="flex" alignItems="center" gap={1}>
                            <WatchLaterOutlinedIcon sx={{ color: "green", fontSize: 18 }} />
                            <span>In: {formatTime(row.attendanceList[0]?.punch_in)}</span>
                          </Box>
                          <Box display="flex" alignItems="center" gap={1}>
                            <WatchLaterOutlinedIcon sx={{ color: "red", fontSize: 18 }} />
                            <span>Out: {formatTime(row.attendanceList[0]?.punch_out)}</span>
                          </Box>
                        </Box>
                        {row.attendanceList.length > 1 &&
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "auto"
                            }}
                          >
                            <Tag
                              style={{
                                borderRadius: "20px",
                                height: "25px",
                                width: "25px",
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                border: 0,
                                backgroundColor: "#244DA0",
                                color: "white",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSelectedAttendanceList(row.attendanceList);
                                setSelectedUserName(row.userName)
                                setopenDialog(true)
                              }}
                            >
                              {row.attendanceList.length}
                            </Tag>
                            {/* <InfoOutlineIcon
                              style={{
                                fontSize: "larger",
                                cursor: "pointer"
                              }}
                              onClick={() => {
                                setSelectedAttendanceList(row.attendanceList);
                                setSelectedUserName(row.userName)
                                setopenDialog(true)
                              }}
                            /> */}

                            {/* <span style={{ fontSize: 14 }}>{row.attendanceList.length}</span> */}
                          </Box>
                        }
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>
                        <FreeBreakfastOutlinedIcon sx={{ color: "orange", fontSize: 20 }} />
                        <span>{formatDuration(row.totalBreakHours)}</span>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>
                        <BusinessCenterOutlinedIcon sx={{ color: "blue", fontSize: 20 }} />
                        <span>{formatDuration(row.totalWorkingHours)}</span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">No records found.</TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </TableContainer>

        <Dialog
          className="Leave_dialog_m"
          open={openDialog}
          onClose={() => setopenDialog(false)}
        >
          <DialogTitle id="dialog_title">
            <Box fontSize={18}>
              {selectedUserName}
            </Box>

            <CloseIcon
              style={{ color: "grey", cursor: "pointer" }}
              onClick={() => setopenDialog(false)}
            />
          </DialogTitle>

          <Divider style={{ margin: "0px", height: "2px", backgroundColor: "#bbbec4ff" }} />

          <DialogContent>
            {selectedAttendanceList?.map((val, index) =>
              <div
                className="Leave_dialog"
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  padding: 1.5,
                  marginBottom: 7,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <WatchLaterOutlinedIcon sx={{ color: "green", fontSize: 18, }} />
                  <Typography variant="subtitle1">Punch In</Typography>
                  <Typography variant="body2">
                    {formatTime(val.punch_in)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <WatchLaterOutlinedIcon sx={{ color: "red", fontSize: 18, }} />
                  <Typography variant="subtitle1">Punch Out</Typography>
                  <Typography variant="body2">
                    {formatTime(val.punch_out)}
                  </Typography>
                </Box>
              </div>
            )}

          </DialogContent>
        </Dialog>

      </Box>
    </Box>
  )
}

export default AdminDashboardUI